import {channelGroupList} from '@divvit/common-channels'

export const channels = channelGroupList.reduce((acc, channelGroup) => {
  channelGroup.channels.forEach(channel => {
    if (channel.id === 'prisjakt') return acc
    acc[channelGroup.id + '/' + channel.id] = {
      id: channelGroup.id + '/' + channel.id,
      label: channel.label,
      channelId: channel.id,
      groupId: channelGroup.id,
      color: channel.id,
      costConnector: channel.costConnector
    }
  })
  return acc
}, {})

export function set(obj, path, value) {
  const pathItem = path.shift()
  if (path.length) {
    obj[pathItem] = obj[pathItem] || {}
    set(obj[pathItem], path, value)
  } else {
    obj[pathItem] = value || {}
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/channels/utils.js